import { render } from "./StandardLogo.vue?vue&type=template&id=13b40463"
import script from "./StandardLogo.vue?vue&type=script&lang=ts"
export * from "./StandardLogo.vue?vue&type=script&lang=ts"
script.render = render

export default script